
/* START_TEMPLATE */
define('hbs!app/templates/_cc_readonly',['hbs','Handlebars','app/templates/_helpers/subview'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.cvv : depth0), {"name":"if","hash":{},"fn":this.program(2, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, (depth0 != null ? depth0.cvv : depth0), {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"4":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "<div class=\"at-row\">\n    ";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, (depth0 != null ? depth0.fa : depth0), {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n  </div>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, lambda=this.lambda, escapeExpression=this.escapeExpression, functionType="function", helperMissing=helpers.helperMissing, buffer = "<div class=\"at-row at-row-full\">\n  <label class=\"at-text at-cc-number at-cc-number-readonly\">"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.CardNumber : stack1), depth0))
    + "\n    <a href=\"#edit-account\" class=\"change-account\">"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.Edit : stack1), depth0))
    + "</a>\n    <div class=\"cc-type-wrapper\">\n      <div class=\"cc-type unknown\"></div>\n      <input readonly disabled name=\"Account\" type=\"tel\" title=\"Credit "
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)))
    + "\" value=\"•••• •••• •••• "
    + escapeExpression(((helper = (helper = helpers.cc_4_digit || (depth0 != null ? depth0.cc_4_digit : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"cc_4_digit","hash":{}}) : helper)))
    + "\">\n    </div>\n  </label>\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.isOberon : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  buffer += "</div>\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.fa : depth0), {"name":"if","hash":{},"fn":this.program(4, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
}});
Handlebars.registerPartial('app/templates/_cc_readonly', t);
Handlebars.registerPartial('./_cc_readonly', t);
return t;
});
/* END_TEMPLATE */
;
